<template>
  <div id="date-picker">
    <label v-if="label" v-html="label"></label>
    <v-date-picker
      v-on="$listeners"
      v-model="date"
      :first-day-of-week="2"
      :masks="{ title: titleFormat, input: inputFormat, L: dateFormat }"
      locale="hu"
      :attributes="attributes"
      :mode="mode"
      is24hr
    >
      <template v-slot="{ inputValue, inputEvents }">
        <input
          class="date-picker-input"
          :value="inputValue"
          v-on="inputEvents"
        />
      </template>
    </v-date-picker>
  </div>
</template>

<script>
export default {
  name: "DatePicker",
  props: {
    value: {
      required: false
    },
    label: {
      type: String,
      required: false
    },
    titleFormat: {
      required: false,
      default: "YYYY MMMM DD"
    },
    dateFormat: {
      required: false,
      default: "YYYY. MMMM DD"
    },
    inputFormat: {
      required: false,
      default: "YYYY-MM-DD"
    },
    attributeDates: {
      required: false,
      default: () => []
    },
    mode: {
      type: String,
      required: false,
      default: "date"
    }
  },
  components: {},
  data: () => ({
    date: undefined
  }),
  created() {
    // if (this.value && this.value !== "Invalid date") {
    //   this.date = this.$moment(this.value).format("YYYY-MM-DD");
    // } else {
    //   this.date = this.$moment().format("YYYY-MM-DD");
    // }
  },
  computed: {
    attributes() {
      return [
        {
          dot: "red",
          dates: this.attributeDates
        }
      ];
    }
  },
  methods: {},
  watch: {
    date() {
      if (this.date !== undefined) {
        this.$emit("input", this.$moment(this.date).format("YYYY-MM-DD"));
      } else {
        this.$emit("input", this.date);
      }
    },
    value() {
      if (this.value !== undefined) {
        this.date = this.$moment(this.value).format("YYYY-MM-DD");
      } else {
        this.date = undefined;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#date-picker {
  .date-picker-input {
    padding: 3px;
    border-radius: 6px;
    border: none;
    width: 100%;
    text-align: center;
    font-size: 20px;
    background: rgba(0, 0, 0, 0.05);
    outline: none;
  }
}
</style>
